import _ from "lodash";

export default class Events {
    constructor(_root) {
        this.events = [];

        if(_root) {
            _root.events = this.events;
            _root.on = this.on;
            _root.off = this.off;
            _root.trigger = this.trigger;
        }
    }

    on(_eventNames, _eventFunction) {
        const _this = this;
        const _events = _eventNames.split(' ');
       
        _.each(_events, (_event) => {
            _event = _event.trim();
            
            const eventName = _event.split('.')[0];
            const eventClass = _event.substring(_event.indexOf('.')+1, _event.length);

            const eventFunction = _eventFunction;

            const event = {eventName, eventClass, eventFunction};

            _this.events.push(event);
        });
        
        return this;
    }

    off(_eventNames) {
        // remove all events
        if(!_eventNames) {
            this.events = [];
            return this;
        }

        const _events = _eventNames.split(' ');

        _.each(_events, (_event) => {
            _event = _event.trim();

            const eventName = _event.split('.')[0];
            const eventClass = _event.substring(_event.indexOf('.')+1, _event.length);

            this.events = _.filter(this.events, (event) => {
                if(event.eventName == eventName && (!eventClass || (eventClass && event.eventClass == eventClass))) {
                    return false;
                }

                return true;
            });
        });

        return this;
    }

    trigger(_eventNames, data, resolve, reject) {
        const _this = this;
        
        // get events and split them by ,
        const _events = _eventNames.split(',');
        
        // loop events
        _.each(_events, function(_event){
            _event = _event.trim();
            
            // split event by . for class name
            const eventName = _event.split('.')[0];
            const eventClass = _event.split('.')[1];
            
            const events = _.filter(_this.events, function(event){
                if(event.eventName == eventName && (!eventClass || (eventClass && event.eventClass == eventClass))) {
                    return true;
                }

                return false;
            });

            // set prevented to false, wait before a on is pausing original function
            let prevented = false;
            
            _.each(events, function(event){
                // generate event object for preventDefault
                const e = {
                    preventDefault: () => {
                        prevented = true;
                    }
                };

                // call on event
                event.eventFunction(e, data);
            });

            // check if some on event is blocked callback with preventDefault
            if(!prevented && typeof resolve == 'function') {
                resolve();
            }
            else if(prevented && typeof reject == 'function') {
                reject();
            }
        });
        
        return this;
    }
};